module.exports = __webpack_public_path__ + "img/green_119.7277d228.png";